import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssistantDirectionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assistant_direction"}/>
}
